// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-xoxk","right":"styles_right__35KfL"};